import { Component, OnInit, Input, Injector } from '@angular/core';
import { NavService, INavItem } from '../../service/common/nav.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-navigation',
  template: `<div class="d-flex flex-row flex-nowrap align-items-center" *ngIf="showNavBar">

    <!-- <button [ngClass]="getNavButtonClass(navItems.length, i)" [style.max-width]="i >= 1? (94/(navItems.length -1)) + '%': ''" [style.cursor]="navItem.routeUrl?'pointer':'auto'" [style.z-index]="navItems.length - i"
    *ngFor="let navItem of navItems; index as i" (click)="navigate(navItem)" id="{{getNavItemId(navItems.length, i)}}" title="{{navItem.tooltip | translate}}" >
    <div [ngClass]="getNavItemClass(navItems.length, i)">
      <div class="navigation-homeitem2" style="max-width: 100%;white-space:nowrap; text-overflow: ellipsis; overflow:hidden; display:inline-block; padding-left: 10px;">
        <i class="fa fa-home" *ngIf="i === 0"></i>
        <span [ngClass]="{'navigationOk': parent.viewerPanelsComponent.maxGlobalUtilization() <= 100, 'navigationNotOk': parent.viewerPanelsComponent.maxGlobalUtilization() > 100 }" *ngIf="i !== 0">{{ navItem.routeName | uppercase }}</span>
      </div>
    </div>
  </button> -->
    <!-- <i *ngIf="parent.viewerPanelsComponent.showWarningIcon()" class="material-icons" style="color: #ea721d;margin-left: -7px;margin-bottom: 2px;">warning</i> -->
</div>`,
  styles: [`.navigation-buttonhome{border:none;background-color:#d8d8d8;width:70px;height:50px}.navigation-buttonhomeattached{border:none;height:33px;-webkit-transform:translate(-1px);transform:translate(-1px);background-color:transparent}.navigation-buttonalone{border:none;height:33px;-webkit-transform:translate(4px);transform:translate(4px);background-color:transparent}.navigation-home{font-family:Roboto,sans-serif;color:#797979;padding-left:10px;padding-right:10px;white-space:nowrap;width:auto;height:31px;margin-right:7px}.navigation-homeitem{font-family:Roboto,sans-serif;z-index:1;color:#797979;padding-left:10px;padding-right:10px;white-space:nowrap;width:auto;height:31px;font-size:18px;font-weight:700;letter-spacing:2px;line-height:24px}.navigation-homeitem:before{z-index:2;-webkit-transform:translate(-18px,54%) rotateZ(64deg) skewX(40deg);transform:translate(-18px,54%) rotateZ(64deg) skewX(40deg);border-width:2px;width:16px;height:13px;position:absolute;border-style:solid solid none none}.navigation-loneitem{font-family:Roboto,sans-serif;z-index:1;border-width:1px;color:#797979;padding-left:10px;padding-right:10px;margin-right:4px;white-space:nowrap;height:31px;font-size:18px;font-weight:700;letter-spacing:2px;line-height:24px}.navigation-loneitem:before{z-index:2;content:'';border-color:#000;border-width:2px;width:9px;height:9px;position:absolute;top:10px;left:-5px;-webkit-transform:rotate(45deg);transform:rotate(45deg);border-style:solid solid none none}`]
})
export class NavigationComponent implements OnInit {
  public showNavBar = false;
  private navItems: Array<INavItem> = [];
  constructor(public translate: TranslateService, private navService: NavService, private router: Router, private inj:Injector) {


    this.navService.$navItemsChanged.subscribe(navItems => {
      if (!navItems) {
        this.showNavBar = false;
      } else {
        this.showNavBar = true;
        this.navItems = navItems;
      }
    });
  }


  navigate(navItem: INavItem) {
    if (navItem.routeUrl) {
      this.router.navigateByUrl(navItem.routeUrl);
    }
  }

  getNavButtonClass(totalItems, itemIndex) {
    if (itemIndex === 0) {
      return 'navigation-buttonhome';
    } else if (itemIndex < (totalItems - 1)) {
      return 'navigation-buttonhomeattached';
    } else {
      return 'navigation-buttonalone';
    }
  }

  getNavItemId(totalItems, itemIndex) {
    if (itemIndex === 0) {
      return 'backToProjects';
    } else if (itemIndex < (totalItems - 1)) {
      return 'backToProject';
    }
  }

  getNavItemClass(totalItems, itemIndex) {
    if (itemIndex === 0) {
      return 'navigation-home';
    } else if (itemIndex < (totalItems - 1)) {
      return 'navigation-homeitem';
    } else {
      return 'navigation-loneitem';
    }
  }

  ngOnInit() {
  }

}
